import { useForm } from '@inertiajs/react'
import PropTypes from 'prop-types'
import Modal from '../ui/Modal'
import Input from '../ui/Input'
import Button from '../ui/Button'

export default function PartnerRulesModal({ isOpen, onClose, partner }) {
  const { data, setData, patch, processing, errors } = useForm({
    commission_split_source: partner.partnership?.custom_rules?.commission_split?.source || 60,
    commission_split_target: partner.partnership?.custom_rules?.commission_split?.target || 40
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    patch(`/collaboration/partners/${partner.id}/rules`, {
      onSuccess: () => onClose()
    })
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Règles pour ${partner.name}`}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p className="text-sm text-blue-800">
            Personnalisez la répartition de commission pour ce partenaire uniquement.
            Cette règle remplacera la configuration par défaut.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <Input
            label="Votre part (%)"
            type="number"
            min="0"
            max="100"
            value={data.commission_split_source}
            onChange={(e) => {
              const source = parseInt(e.target.value)
              setData({
                commission_split_source: source,
                commission_split_target: 100 - source
              })
            }}
            error={errors.commission_split_source}
          />

          <Input
            label="Part partenaire (%)"
            type="number"
            value={data.commission_split_target}
            disabled
            help="Calculé automatiquement"
          />
        </div>

        <div className="flex justify-end gap-2 pt-4 border-t">
          <Button variant="outline" onClick={onClose}>
            Annuler
          </Button>
          <Button type="submit" disabled={processing}>
            {processing ? 'Enregistrement...' : 'Enregistrer'}
          </Button>
        </div>
      </form>
    </Modal>
  )
}

PartnerRulesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  partner: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    partnership: PropTypes.object
  }).isRequired
}
